var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.downloadPDF()}}},[_vm._v("Download Wipe Report")])}
var staticRenderFns = []

export { render, staticRenderFns }